var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgDivisionOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 95,
    viewBox: "0 0 86 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.436035,
    width: 55.833,
    height: 71.3422,
    rx: 2,
    fill: "#E7F0F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4077,
    y: 15.9717,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95361,
    y: 14.9072,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95361,
    y: 25.5547,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95361,
    y: 36.2026,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.95361,
    y: 46.8521,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4077,
    y: 26.6201,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4077,
    y: 37.2676,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4077,
    y: 47.917,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4907,
    y: 8.39355,
    width: 55.833,
    height: 71.3422,
    rx: 2,
    transform: "rotate(10.3871 24.4907 8.39355)",
    fill: "#B9D6EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3208,
    y: 26.9829,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    transform: "rotate(10.3871 37.3208 26.9829)",
    fill: "#2974B2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1816,
    y: 24.5918,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    transform: "rotate(10.3871 30.1816 24.5918)",
    fill: "#093E62"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2612,
    y: 35.0654,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    transform: "rotate(10.3871 28.2612 35.0654)",
    fill: "#093E62"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3423,
    y: 45.5391,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    transform: "rotate(10.3871 26.3423 45.5391)",
    fill: "#093E62"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4219,
    y: 56.0132,
    width: 4.25924,
    height: 4.25924,
    rx: 1,
    transform: "rotate(10.3871 24.4219 56.0132)",
    fill: "#093E62"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4014,
    y: 37.4565,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    transform: "rotate(10.3871 35.4014 37.4565)",
    fill: "#2974B2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 33.481,
    y: 47.9302,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    transform: "rotate(10.3871 33.481 47.9302)",
    fill: "#2974B2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5615,
    y: 58.4043,
    width: 29.8147,
    height: 2.12962,
    rx: 1,
    transform: "rotate(10.3871 31.5615 58.4043)",
    fill: "#2974B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 91.5714C77.3907 91.5714 82.5714 86.3907 82.5714 80C82.5714 73.6093 77.3907 68.4286 71 68.4286C64.6093 68.4286 59.4286 73.6093 59.4286 80C59.4286 86.3907 64.6093 91.5714 71 91.5714ZM71 95C79.2843 95 86 88.2843 86 80C86 71.7157 79.2843 65 71 65C62.7157 65 56 71.7157 56 80C56 88.2843 62.7157 95 71 95Z",
    fill: "#093E62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7143 71.8571L62 91.5713L59.5757 89.147L79.29 69.4327L81.7143 71.8571Z",
    fill: "#093E62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDivisionOrder);
export default __webpack_public_path__ + "static/media/imgDivisionOrder.c8828162c51a9cbbe27fb8185f116766.svg";
export { ForwardRef as ReactComponent };